import { connect } from 'react-redux';

import { MortgageInRent } from './mortgage-in-rent';
import { IState } from '../../../../store';
import { ITrackingReducerState } from '../../../../store/tracking';

export interface IMortgageInRentStateProps {
  tracking: ITrackingReducerState;
}

export const mapStateToProps = (state: IState): IMortgageInRentStateProps => {
  return {
    tracking: state.tracking,
  };
};

export const MortgageInRentContainer = connect<IMortgageInRentStateProps>(mapStateToProps)(MortgageInRent);
